<ng-container *ngFor="let item of displayItems">
  <ng-container *ngFor="let value of item.values">
    <span>
      <span [innerHTML]="separator" aria-hidden="true"></span>
      <span class="{{ item.class }}" [attr.data-value]="value" [innerHTML]="value"></span>
    </span>
  </ng-container>
</ng-container>
<app-screen-tag *ngIf="screenTag" [model]="screenTag"></app-screen-tag>

@if (fields.includes('movieSoundType') && model?.movieSoundType === 'ATM') {
<i class="icon icon-dolby-atmos" [attr.aria-label]="'screen.feature.dolby-atmos' | translate"></i>
}
